import React, { useContext, useState } from "react";
import { Wrapper, InputWrapper, Prefix, Label } from "./styled.js";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { AppContext } from "hocs/withAppContext";
import DropdownMenu from "../DropdownMenu";
import { ReactComponent as ChevronDown } from 'assets/svgs/chevron-down.svg';

export const TaxInput = ({ label, placeholder, required,
                            value, onChange, disabled}) => {
    const { currencySymbol } = useContext(AppContext);

    const [display, setDisplay] = useState(false);
    const [taxType, setTaxType] = useState(currencySymbol);

    const options = [
        { label: `${currencySymbol} - Fixed`, value: currencySymbol },
        { label: '% - Percentage', value: '%' },
    ];

    const handleOnChange = (type, value) => {
        if (!onChange) {
            return;
        }

        onChange([type, value]);
    };

    const handleTaxTypeChange = (opt) => {
        setDisplay(!display);
        setTaxType(opt.value);
        handleOnChange(opt.value, value);
    };

    return <Wrapper>
        {label && <Label required={required}>{label}</Label>}
        <InputWrapper>
            <DropdownMenu
                menuItems={options}
                display={display}
                width="130"
                offsetX="0"
                offsetY="45"
                direction="bottom-right"
                onChange={handleTaxTypeChange}
            >
                <Prefix disabled={disabled}
                        onClick={() => setDisplay(!display)}>
                    {taxType}
                    <ChevronDown/>
                </Prefix>
            </DropdownMenu>
            <input
                min="0"
                type="number"
                placeholder={placeholder}
                required={required}
                value={value}
                onChange={e => handleOnChange(taxType, parseFloat(e.target.value))}
                disabled={disabled}
            />
        </InputWrapper>
    </Wrapper>
};

export default TaxInput;
